<nz-page-header class="page-header" nzTitle="User Management"></nz-page-header>

<nz-card>
  <div class="row m-b-30">
    <div class="col-lg-4">
      <div class="d-md-flex">
        <nz-input-group [nzPrefix]="prefixTemplate">
          <input type="text" nz-input placeholder="Search" [(ngModel)]="search">
        </nz-input-group>
        <ng-template #prefixTemplate>
          <i nz-icon nzType="search" class="opacity-05"></i>
        </ng-template>
      </div>
    </div>
    <div class="col-lg-8 text-right">
      <button nz-button nzType="primary" (click)="buildUserModal()"><i nz-icon nzType="plus-circle"
                                                                       nzTheme="outline"></i>New user
      </button>
    </div>
  </div>
  <nz-divider></nz-divider>
  <nz-table #basicTable [nzData]="users" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
    <tr>
      <th>User Name</th>
      <th>First Name</th>
      <th>Last Name</th>
      <th>Email</th>
      <th>Phone</th>
      <th>Registration Date</th>
      <th>Role</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of basicTable.data">
      <td>{{item.login}}</td>
      <td>{{item.firstName}}</td>
      <td>{{item.lastName}}</td>
      <td>{{item.email}}</td>
      <td>{{item.phone || ''}}</td>
      <td>{{item.createdDate | date:'dd-MM-yyyy HH:mm'}}</td>
      <td>
        <div *ngFor="let authority of item.authorities">
          <nz-tag [nzColor]="'#108ee9'">{{ authority }}</nz-tag>
        </div>
      </td>
      <td class="text-md-right">
        <a class="m-r-5" nz-button nzType="default" nzGhost
           nzShape="circle" nz-tooltip nzTitle="Edit" nzPlacement="bottom" (click)="buildUserModal(item)">
          <i nz-icon nzType="edit" theme="outline"></i>
        </a>
        <a nz-popconfirm nzPopconfirmTitle="Are you sure to deactivate this user?"
           (nzOnConfirm)="confirmDelete(item.login)"
           (nzOnCancel)="cancelDelete()">
          <i nz-icon nzType="delete" theme="outline"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="page" [nzTotal]="totalItems" [nzPageSize]="size"
                   [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)"></nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ totalItems }} items
    </ng-template>
  </div>
</nz-card>
